module.exports = __webpack_public_path__ + "static/digital7a6aa768f67da8f0c99cfdc4917ecb665.png";